<template>
    <div id="Infoshipp" class="flex flex-col w-full h-auto px-4 mb-12">
        <!-- Header -->
        <div class="flex w-full h-auto justify-center items-center mb-3">
            <span class="Helvetica text-2xl font-bold text-blue-500 justify-center normal-case">Payement Information</span>
        </div>
            <!-- **********Shipping info*********** -->
                 <div class="flex bg-white w-full space-x-2">
                        <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full mt-1">
                                <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-400">person</i>
                                </span>

                                <div class="ml-5 w-full pb-4">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                        Payement information
                                    </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="tab-content">
                                      <div id="latest-tasks-new" class="tab-pane active">
                                          <div class="flex items-center">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Seller </span>
                                                 <div class="text-gray-600">{{ item.seller.fullName}}</div>
                                               </div>
                                          </div>
                                           <div class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">NB Orders </span>
                                                 <div class="text-gray-600">{{ item.count}}</div>
                                               </div>
                                          </div>
                                          <div class="flex items-center mt-5">
                                            <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                              <span  class="font-medium">Amount</span>
                                              <div class="text-gray-600">{{ item.amount }} <sup>{{currency}}</sup></div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        
                          <!-- ****************************** Order Information *********************************************-->

                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                            </span>

                            <div class="ml-5 w-full">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                     Info to update
                                </div>

                                <div class="w-full space-y-4">
                                  
                                        <div 
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="status" :style="colorStatus(item.status)" class="bg-white text-gray-700 px-1">Status
                                                        <span :class="$colors.required">*</span>
                                                    </label>
                                                </p>
                                            </div>
                                            <p>
                                             <select  :style="colorStatus(item.status)"  v-model="item.status" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                <option class="bg-white" selected :value="null"> Status </option>
                                                <option class="bg-white text-gray-600" v-for="(value, index) in statusShipp" :key="index" :value="value">
                                                    {{ value }}
                                                </option>
                                            </select>
                                            </p>
                                        </div>
                                         <div   class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                <label for="category" class="bg-white text-gray-700 px-1">Date Payement <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            
                                            <p>
                                                <datetime-v2 type="datetime" v-model="item.date" :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')"
                                                     placeholder="Payement date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                                            </p>
                                        </div>
                                        
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
    </div>
</template>
<script>
export default {
    props: {
        config: { required: true, type: Object},
        item:{ default: [] },
        index:{ type: Number },
        currentUser:{ type: Object },
        statusShipp:{ type: Array }, 
        currency:{ type: String },
    },
    data() {
        return {

        }
    },
    async mounted() {
       
    },   
    methods: {
    colorStatus(status) {
            switch (status) {
                 case 'pending':
                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                    break;
                case 'processed':
                    return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                    break;
            }
        },
    },
}
</script>
<style scoped>
 .seller-select .vs__dropdown-toggle {
    border: none;
}
</style>